$(function(){
	$('.js-slider').slick({
		autoplay: true, 
		autoplaySpeed: 0, 
		speed: 10000,
		cssEase: "linear", 
		variableWidth: true,
		swipe: false, 
		arrows: false, 
		pauseOnFocus: false,
		pauseOnHover: false, 
	});
});